import URIS from 'constants/uris';
import http from 'services/http';

getRiskProfile.operation = 'READ';
getRiskProfile.idFrom = () => 'getRiskProfileId';
export function getRiskProfile() {
  return http.get(`${URIS.RISK_PROFILE}`);
}
